import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Clinic } from '@models/clinic';
import { ClinicsService } from '@services/clinics.service';

@Component({
  selector: 'app-org-portal-style-settings',
  templateUrl: './org-portal-style-settings.component.html',
  styleUrls: ['./org-portal-style-settings.component.less'],
})
export class OrgPortalStyleSettingsComponent {
  private _clinic: Clinic;
  @Input() set clinic(clinic: Clinic) {
    this._clinic = clinic;
    this.styleForm.patchValue(clinic);
  }
  get clinic() {
    return this._clinic;
  }
  @Output() clinicChange = new EventEmitter<Clinic>();

  loading = false;
  styleForm = new FormGroup({
    portalColourPrimary: new FormControl(null, Validators.required),
    portalColourSecondary: new FormControl(null, Validators.required),
    portalColourAccent: new FormControl(null, Validators.required),
    portalColourMenuFont: new FormControl(null, Validators.required),
  });

  constructor(private clinicsService: ClinicsService) {}

  async updateSettings() {
    this.loading = true;
    const clinic = await this.clinicsService.getClinicById(this.clinic.clinicId).toPromise();
    clinic.portalColourPrimary = this.styleForm.get('portalColourPrimary').value;
    clinic.portalColourSecondary = this.styleForm.get('portalColourSecondary').value;
    clinic.portalColourAccent = this.styleForm.get('portalColourAccent').value;
    clinic.portalColourMenuFont = this.styleForm.get('portalColourMenuFont').value;
    await this.clinicsService.updateClinic(clinic).toPromise();
    this.styleForm.markAsPristine();
    this.clinicChange.emit(structuredClone(clinic));
    this.loading = false;
  }

  resetSettings() {
    this.styleForm.patchValue(this.clinic);
    this.styleForm.markAsPristine();
  }
}
